import dayjs from "dayjs"; 
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router";
import { motion } from "framer-motion";
import Popover from "@mui/material/Popover";
import IRMenu from "./IRMenu";
import KeyManagerialPersonsModal from "./KeyManagerialPersonsModal";
import commoncss from "../../../myfin_v2/css/common.module.css"
import buttoncss from "../../../myfin_v2/css/button.module.css";
import investmentRegisterCss from "../../../myfin_v2/css/investmentRegister.module.css";
import { getInvestment } from "../../../WorkSpace/Components/ApiServices/apiHandler";

import { Button } from "../../../myfin_v2/elements/Button";
import { ReactComponent as PlusIcon } from "../../../myfin_v2/assets/icons/plus.svg";
import { ReactComponent as PlusPrimaryIcon } from "../../../myfin_v2/assets/icons/plusprimary.svg";
import { ReactComponent as MenuDotsIcon } from "../../../myfin_v2/assets/icons/menu_dot.svg";
import { ReactComponent as EditIcon } from "../../../myfin_v2/assets/icons/edit.svg";
import { ReactComponent as DownGreyIcon } from "../../../myfin_v2/assets/icons/down_grey.svg";



const KeyManagerialPersons = () => {

    const { irId } = useParams();
    console.log("URL irId =", irId);
    const history = useHistory();

    // const keyManagerialPersonsData = [
    //     {
    //         _id: "1",
    //         name: "Ravi Kumar",
    //         designation: "Managing Director",
    //         dateOfAppointment: "15-04-2018",
    //         dateOfResignation: "",
    //     },
    //     {
    //         _id: "2",
    //         name: "Sneha Patel",
    //         designation: "Chief Financial Officer",
    //         dateOfAppointment: "07-10-2019",
    //         dateOfResignation: "",
    //     },
    //     {
    //         _id: "3",
    //         name: "Arjun Mehta",
    //         designation: "Independent Director",
    //         dateOfAppointment: "01-05-2020",
    //         dateOfResignation: "30-09-2023",
    //     },
    //     {
    //         _id: "4",
    //         name: "Neha Sharma",
    //         designation: "Company Secretary",
    //         dateOfAppointment: "03-12-2021",
    //         dateOfResignation: "",
    //     },
    //     {
    //         _id: "5",
    //         name: "Vikram Singh",
    //         designation: "Non-Executive Director",
    //         dateOfAppointment: "20-11-2022",
    //         dateOfResignation: "",
    //     },
    // ];

    // const nameOptions = [
    //     "Ravi Kumar",
    //     "Sneha Patel",
    //     "Arjun Mehta",
    //     "Neha Sharma",
    //     "Vikram Singh",
    //  ];

    //     const designationOptions = [
    //     "Managing Director",
    //     "Chief Financial Officer",
    //     "Independent Director",
    //     "Company Secretary",
    //     "Non-Executive Director",
    //  ];


    // const nameOptions = [
    //     "Ravi Kumar",
    //     "Sneha Patel",
    //     "Arjun Mehta",
    //     "Neha Sharma",
    //     "Vikram Singh",
    //  ];

    //     const designationOptions = [
    //     "Managing Director",
    //     "Chief Financial Officer",
    //     "Independent Director",
    //     "Company Secretary",
    //     "Non-Executive Director",
    //  ];



    const [anchorEl, setAnchorEl] = useState(null);
    const [openPopoverId, setOpenPopoverId] = useState(null);
    const [selectedData, setSelectedData] = useState(null);
    const [modalOpen, setModalOpen] = useState(false)
    const [modalType, setModalType] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [keyPersons, setKeyPersons] = useState([]);
    const [editableRows, setEditableRows] = useState([]);




    const open = Boolean(anchorEl);

    const handleAdd = () => {
        setSelectedData(null);
        setModalType("add");
        setModalOpen(true);
    };

    const handleMenuClick = (event, id) => {
        setAnchorEl(event.currentTarget);
        setOpenPopoverId(id);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setOpenPopoverId(null);
    };

    const handleEdit = (item) => {
        setSelectedData(item);
        setModalType("edit");
        setModalOpen(true);
        handleClose();
    };

    const handleDelete = (id) => {
        console.log("Delete clicked for:", id);
        handleClose();
    };

    const handleModalClose = () => {
        setModalOpen(false);
        setSelectedData(null);
        setModalType(null);
    };

    const handleRowChange = (id, field, value) => {
    setEditableRows((prev) =>
        prev.map((row) =>
        row._id === id ? { ...row, [field]: value } : row
        )
    );
    };

    const nameOptions = keyPersons.map((p) => p.name);

    const designationOptions = keyPersons.map((p) => p.designation);


  const fetchKeyManagerialPersons = async () => {
  try {
    console.log(" Fetching Key Persons for ID:", irId);

    const res = await getInvestment(irId);

    if (res.data.success) {
      const persons =
        res.data.investmentRegister?.keyManagerialPersons || [];

      setKeyPersons(persons);
      setEditableRows(persons);
    }
  } catch (error) {
    console.log("Error fetching Key Managerial Persons:", error);
  }
};

useEffect(() => {
  console.log("URL irId =", irId);
}, [irId]);


   useEffect(() => {
  if (irId) fetchKeyManagerialPersons();
}, [irId]);
    return (
        <>
            <div className={`d-flex ${commoncss.pageContent}`}>
                <IRMenu
                    activeTab={"Key Managerial Persons"}
                    registerID={irId}
                />
                <motion.div
                    initial={{ x: 200, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: 200, opacity: 0 }}
                    transition={{ duration: 1, ease: "easeInOut" }}
                    className={investmentRegisterCss.irLayout}
                >
                    <div className={investmentRegisterCss.iRHeader}>
                        {/* <Button
                            btnColor={buttoncss.primary}
                            icon={<PlusIcon />}
                            label="Create Investment"
                            onClick={() => { history.push(`/create-investment/${irId}`) }}
                        /> */}
                    </div>
                    <div className={investmentRegisterCss.tableLayout}>
                        <div className={investmentRegisterCss.tableConatiner}>
                           <div className={investmentRegisterCss.tableTitle}>
                            <span>Key Managerial Persons</span>

                            {!isEditing ? (
                                <span className="d-flex gap-1">
                            <Button
                                btnColor={buttoncss.greyBg}
                                icon={<EditIcon />}
                                class_={investmentRegisterCss.editBtn}
                                onClick={() => setIsEditing(true)}
                            />

                            <Button
                                btnColor={buttoncss.greyBg}
                                icon={<PlusPrimaryIcon />}
                                class_={investmentRegisterCss.addBtnRow}
                                onClick={handleAdd}
                            />
                            </span>
                        ) : (
                            <div className={investmentRegisterCss.saveCancelWrap}>
                        
                            <button
                                className={investmentRegisterCss.cancelBtn}
                                onClick={() => {
                                setIsEditing(false);
                                setEditableRows([...keyPersons]);
                                }}
                            >
                                Cancel
                            </button>

                            <button
                                className={investmentRegisterCss.saveBtn}
                                onClick={() => {
                                console.log("Saved Data:", editableRows);
                                setIsEditing(false);
                                }}
                            >
                                Save
                            </button>
                            </div>
                        )}
                        </div>

                            <table>
                                <thead>
                                    <tr>
                                        <th style={{ textAlign:"left" }}>Name</th>
                                        <th style={{ textAlign:"left" }}>Designation</th>
                                        <th>Date of appointment</th>
                                        <th>Date of resignation</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                   {editableRows.map((item) => (
                                        <tr key={item._id}>
                                            <td style={{textAlign: "left"}}>
                                            {isEditing ? (
                                                <div className={investmentRegisterCss.dropdownWrapper}>
                                                <select
                                                    value={item.name}
                                                    onChange={(e) =>
                                                    handleRowChange(item._id, "name", e.target.value)
                                                    }
                                                    className={investmentRegisterCss.dropdownInput}
                                                >
                                                    {nameOptions.map((opt) => (
                                                    <option key={opt} value={opt}>
                                                        {opt}
                                                    </option>
                                                    ))}
                                                </select>

                                                <span className={investmentRegisterCss.dropdownArrow}>
                                                    <DownGreyIcon />
                                                </span>
                                                </div>
                                            ) : (
                                                item.name
                                            )}
                                            </td>


                                          <td style={{ textAlign: "left"}}>
                                            {isEditing ? (
                                                <div className={investmentRegisterCss.dropdownWrapper}>
                                                <select
                                                    value={item.designation}
                                                    onChange={(e) =>
                                                    handleRowChange(item._id, "designation", e.target.value)
                                                    }
                                                    className={investmentRegisterCss.dropdownInput}
                                                >
                                                    {designationOptions.map((opt) => (
                                                    <option key={opt} value={opt}>
                                                        {opt}
                                                    </option>
                                                    ))}
                                                </select>

                                                <span className={investmentRegisterCss.dropdownArrow}>
                                                    <DownGreyIcon />
                                                </span>
                                                </div>
                                            ) : (
                                                item.designation
                                            )}
                                            </td>


                                            <td>
                                            {isEditing ? (
                                                <input
                                                type="date"
                                                className={investmentRegisterCss.dateInputSmall}
                                                placeholder="DD-MM-YYYY"
                                                value={
                                                    item.dateOfAppointment
                                                    ? dayjs(item.dateOfAppointment).format("YYYY-MM-DD")
                                                    : ""
                                                }
                                                onChange={(e) =>
                                                    handleRowChange(item._id, "dateOfAppointment", e.target.value)
                                                }
                                                />
                                            ) : item.dateOfAppointment ? (
                                                dayjs(item.dateOfAppointment).format("DD-MMM-YYYY")
                                            ) : (
                                                "-"
                                            )}
                                            </td>
                                             <td>
                                            {isEditing ? (
                                                <input
                                                type="date"
                                                placeholder="DD-MM-YYYY"
                                                value={
                                                    item.dateOfResignation
                                                    ? dayjs(item.dateOfResignation).format("YYYY-MM-DD")
                                                    : ""
                                                }
                                                className={investmentRegisterCss.dateInputSmall}
                                                onChange={(e) =>
                                                    handleRowChange(item._id, "dateOfResignation", e.target.value)
                                                }
                                                                                                                                                    
                                                />
                                            ) : item.dateOfResignation ? (
                                                dayjs(item.dateOfResignation).format("DD-MMM-YYYY")
                                            ) : (
                                                "-"
                                            )}
                                            </td>


                                             <td>
                                                <MenuDotsIcon
                                                    style={{ cursor: "pointer", marginRight: 20 }}
                                                    onClick={(e) => handleMenuClick(e, item._id)}
                                                />
                                                <Popover
                                                    open={open && openPopoverId === item._id}
                                                    anchorEl={anchorEl}
                                                    onClose={handleClose}
                                                    anchorOrigin={{
                                                        vertical: "bottom",
                                                        horizontal: "left",
                                                    }}

                                                >
                                                    <div className={investmentRegisterCss.irOptions}>
                                                        <span
                                                            style={{ borderBottom: "1px solid #EAEEED" }}
                                                            onClick={() => handleEdit(item)}
                                                        >
                                                            Edit
                                                        </span>
                                                        <span onClick={() => handleDelete(item._id)}>Delete</span>
                                                    </div>

                                                </Popover>
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                        </div>
                    </div>

                </motion.div>
            </div>
            {modalOpen && (
                <KeyManagerialPersonsModal
                    handleClose={handleModalClose}
                    data={selectedData}
                    type={modalType}
                    investmentID={irId}
                    refreshData={fetchKeyManagerialPersons}  
 
                />
            )}
        </>
    )
}

export default KeyManagerialPersons;